import { SensorOrSubSensorInfoByType } from '@components/cockpit/panels/monitoring/monitoring.types';
import DataSheetCard from '@components/common/layout/DataSheetCard';
import { useSkyJackerCommand } from '@hooks/useSkyJackerCommand';
import { useIntl } from 'react-intl';

import { SensorTypeEnum } from '@/types/sensor/sensors';

export default function SkyJackerCommands(
  sensorOrSubSensorInfo: Readonly<SensorOrSubSensorInfoByType<SensorTypeEnum.SKY_JACKER>>,
) {
  const { formatMessage } = useIntl();

  const { setEmission, sensorTracking, isLoading } = useSkyJackerCommand(sensorOrSubSensorInfo);

  const handleClick = (action: 'startEmission' | 'stopEmission') => {
    switch (action) {
      case 'startEmission': {
        setEmission(true);
        return;
      }
      case 'stopEmission': {
        setEmission(false);
        sensorTracking(null);
        return;
      }
    }
  };

  const emissionActions = [
    {
      action: 'startEmission',
      i18nKey: 'sensors.tab.commands.skyjacker.emission.startEmission',
    },
    {
      action: 'stopEmission',
      i18nKey: 'sensors.tab.commands.skyjacker.emission.stopEmission',
    },
  ] as const;

  return (
    <DataSheetCard
      actions={emissionActions}
      description={formatMessage({ id: 'sensors.tab.commands.skyjacker.emission.emissionDescription' })}
      isLoading={isLoading}
      isDisabled={isLoading}
      onClick={handleClick}
    />
  );
}
